// src/components/EndScreen.js
import React from "react";

function EndScreen({ finalScore, playAgain }) {
  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold mb-4">Game Over!</h1>
      <p className="text-xl mb-4">Your Final Score: {finalScore}</p>
      <button
        className="bg-blue-700 text-white px-6 py-2 rounded"
        onClick={playAgain}
      >
        Play Again
      </button>
    </div>
  );
}

export default EndScreen;
